module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-09.3123d32a.jpg";